/**
 * <podmuch-bundle>
 * Wires the colour picker and bundle (quantity) picker to the native Horizon
 * <product-form-component> that wraps the same subtree:
 *   - colour  -> updates the hidden input[name="id"] (variant id)
 *   - bundle  -> updates the hidden input[name="quantity"] + the CTA price
 * The actual add-to-cart is handled by Horizon's product-form (AJAX + drawer).
 * No localStorage, no persistence.
 */
class PodmuchBundle extends HTMLElement {
  connectedCallback() {
    this.variantInput = this.querySelector('input[name="id"]');
    this.quantityInput = this.querySelector('input[name="quantity"]');
    this.ctaPrice = this.querySelector('[data-pod-cta-price]');
    this.addToCart = this.querySelector('add-to-cart-component');
    this.submitButton = this.querySelector('[ref="addToCartButton"]');
    this.colorButtons = Array.from(this.querySelectorAll('[data-pod-color]'));
    this.packButtons = Array.from(this.querySelectorAll('[data-pod-pack]'));

    this.handleColorClick = (event) => this.selectColor(event.currentTarget);
    this.handlePackClick = (event) => this.selectPack(event.currentTarget);

    this.colorButtons.forEach((button) => button.addEventListener('click', this.handleColorClick));
    this.packButtons.forEach((button) => button.addEventListener('click', this.handlePackClick));
  }

  disconnectedCallback() {
    this.colorButtons?.forEach((button) => button.removeEventListener('click', this.handleColorClick));
    this.packButtons?.forEach((button) => button.removeEventListener('click', this.handlePackClick));
  }

  /** @param {HTMLElement} button */
  selectColor(button) {
    this.colorButtons.forEach((el) => {
      const selected = el === button;
      el.classList.toggle('is-selected', selected);
      el.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    if (this.variantInput && button.dataset.variantId) {
      this.variantInput.value = button.dataset.variantId;
    }

    if (this.addToCart && button.dataset.variantMedia) {
      this.addToCart.setAttribute('data-product-variant-media', button.dataset.variantMedia);
    }

    this.setAvailable(button.dataset.available !== 'false');
  }

  /** @param {HTMLElement} button */
  selectPack(button) {
    this.packButtons.forEach((el) => {
      const selected = el === button;
      el.classList.toggle('is-selected', selected);
      el.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    if (this.quantityInput && button.dataset.quantity) {
      this.quantityInput.value = button.dataset.quantity;
    }

    if (this.ctaPrice && button.dataset.price) {
      this.ctaPrice.textContent = button.dataset.price;
    }
  }

  /** @param {boolean} available */
  setAvailable(available) {
    if (this.submitButton) this.submitButton.disabled = !available;
    this.classList.toggle('is-soldout', !available);
  }
}

if (!customElements.get('podmuch-bundle')) {
  customElements.define('podmuch-bundle', PodmuchBundle);
}
